import Loadable from 'app/components/Loadable';
import { lazy } from 'react';


 const Translate = Loadable(lazy(() => import('./Translate')));






const TranslateRoutes = [
   { path: '/translate', element: <Translate /> },
];

export default TranslateRoutes;